<template>
  <div class="cbaas-detail-section">
    <div v-if="showTitle" class="title">
      <span class="title-icon"></span>
      <span>{{ title }}</span>
      <span class="fill"></span>
      <slot name="actions"></slot>
    </div>
    <div class="content">
      <div v-if="showInnerActions" class="inner-actions">
        <slot name="inner-actions"></slot>
      </div>
      <div v-if="showBorder" class="border">
        <slot></slot>
      </div>
      <slot v-else></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailSection',
  props: {
    title: {
      type: String,
      default: ''
    },
    showTitle: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    showBorder: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    showInnerActions: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'cbaas-detail-section',
  (
    --cbaas-detail-section-title-color: #fff,
    --cbaas-detail-section-content-border-color: #33496e
  ),
  (
    --cbaas-detail-section-title-color: #192227,
    --cbaas-detail-section-content-border-color: #ebebeb
  )
);
.cbaas-detail-section {
  @include adaptation(
    (
      --cbaas-detail-section-padding: 4px 16px,
      --cbaas-detail-section-title-padding: 12px 0,
      --cbaas-detail-section-title-line-height: 20px,
      --cbaas-detail-section-title-fontsize: 14px,
      --cbaas-detail-section-title-icon-width: 19px,
      --cbaas-detail-section-title-icon-height: 9px,
      --cbaas-detail-section-title-icon-margin-right: 8px,
      --cbaas-detail-section-content-padding: 12px 0,
      --cbaas-detail-section-content-inner-actions-margin-bottom: 16px,
      --cbaas-detail-section-content-border-radius: 2px,
      --cbaas-detail-section-content-border-width: 1px
    )
  );
  padding: var(--cbaas-detail-section-padding);

  .title {
    display: flex;
    align-items: center;
    color: var(--cbaas-detail-section-title-color);
    font-size: var(--cbaas-detail-section-title-fontsize);
    font-weight: 500;
    padding: var(--cbaas-detail-section-title-padding);
    line-height: var(--cbaas-detail-section-title-line-height);

    .title-icon {
      display: inline-block;
      width: var(--cbaas-detail-section-title-icon-width);
      height: var(--cbaas-detail-section-title-icon-height);
      flex-shrink: 0;
      background-image: url('~@/assets/images/components/plate/plate-title-icon.png');
      background-size: 100% 100%;
      margin-right: var(--cbaas-detail-section-title-icon-margin-right);
    }

    .fill {
      flex-grow: 1;
    }
  }

  .content {
    padding: var(--cbaas-detail-section-content-padding);

    .inner-actions {
      margin-bottom: var(--cbaas-detail-section-content-inner-actions-margin-bottom);
    }

    .border {
      border-radius: var(--cbaas-detail-section-content-border-radius);
      border: var(--cbaas-detail-section-content-border-width) solid
        var(--cbaas-detail-section-content-border-color);
    }
  }
}
</style>
